import { render } from "./InHouseIndex.vue?vue&type=template&id=666145b2&scoped=true"
import script from "./InHouseIndex.vue?vue&type=script&lang=js"
export * from "./InHouseIndex.vue?vue&type=script&lang=js"

import "./InHouseIndex.vue?vue&type=style&index=0&id=666145b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-666145b2"]])

export default __exports__